module.exports = __webpack_public_path__ + "static/media/solved-example-eclipse.7ffa5fd4.png";